import {GET_ALL_LOCATIONS, GET_PROMO_CODES} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formattedDate} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('packages'),
                url: GET_PROMO_CODES,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('package'),
                        type: 'custom-html',
                        key: 'code',
                        isVisible: true,
                        modifier: (name) => {
                            return name ? name: '-';
                        }
                    },
                    {
                        title: this.$t('days_extension'),
                        type: 'custom-html',
                        key: 'days_extension',
                        isVisible: true,
                        modifier: (days) => {
                            return days ? days : '-';
                        }
                    },
                    {
                        title: this.$t('usage_limit'),
                        type: 'custom-html',
                        key: 'usage_limit',
                        isVisible: true,
                        modifier: (limit) => {
                            return limit ?? '-';
                        }
                    },
                    {
                        title: this.$t('expires_at'),
                        type: 'custom-html',
                        key: 'expires_at',
                        isVisible: true,
                        modifier: (expires_at) => {
                            return expires_at ? formattedDate(expires_at) : '-';
                        }
                    },
                    {
                        title: this.$t('usage_count'),
                        type: 'custom-html',
                        key: 'usage_count',
                        isVisible: true,
                        modifier: (usage_count) => {
                            return usage_count ?? '-';
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'string_status',
                        isVisible: true,
                        modifier: (row) => {
                            return `<span class="badge-pill ${row.class} text-capitalize">${this.$t(row.value)}</span>`;
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        key: "edit",
                        modifier: row => {
                            return this.$can('update_locations') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        url: GET_PROMO_CODES,
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        name: 'delete',
                        modifier: row => {
                            return this.$can('update_locations') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    }
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        renewSubscription(id) {
            const url = `${window.location.origin}/subscription/invoice/${id}/download`;
            console.log(url);
            // window.open(url, '_blank'); // Open the invoice in a new tab or download directly
        },
        triggerActions(row, action, active) {


            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            if (action.key === 'edit') {
                // this.promptIcon = action.icon;
                // this.employeeId = row.id;
                // this.modalClass = action.modalClass;
                // console.log(row, action);
                // this.selectedUrl = `${action.url}/${row.id}`;
                // this.isModalActive = true;
                // this.promptIcon = action.icon;
                // this.employeeId = row.id;
                // this.modalClass = action.modalClass;
            }

        },
    }
}